import React from 'react';
import { Box, BoxProps, Theme, withStyles } from '@material-ui/core';
import { TypographyAllProps } from 'globals/types';
import { red } from 'globals/colors';
import FsBodySmall from 'ui-elements/typography/FsBodySmall';
import FsBodyBold from 'ui-elements/typography/FsBodyBold';
import FsCaption from 'ui-elements/typography/FsCaption';

export const ContainerBox = withStyles(
  ({ spacing, palette, transitions }: Theme) => ({
    root: {
      position: 'relative',
      display: 'flex',
      marginBottom: spacing(2),
      paddingTop: spacing(2),
      borderTop: `1px solid ${palette.grey[200]}`,
      cursor: 'pointer',
      '&::after': {
        content: '""',
        position: 'absolute',
        top: '50%',
        right: spacing(2),
        width: spacing(1.5),
        height: spacing(1.5),
        borderRadius: '50%',
        backgroundColor: red.V1,
        transition: transitions.create(['transform']),
      },
      '&:hover::after': {
        transform: `scale(2)`,
      },
      '&.isClicked::after': {
        transform: `scale(0)`,
      },
      '&.isRead::after': {
        display: 'none',
      },
    },
  })
)((props: BoxProps) => <Box {...props} />);

export const IconWrapperBox = withStyles(({ spacing }: Theme) => ({
  root: {
    marginRight: spacing(2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}))(Box);

export const Name = withStyles({})((props: TypographyAllProps) => (
  <FsBodyBold component="h4" {...props} />
));

export const ReferenceBox = withStyles(() => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'baseline',
  },
}))(Box);

export const ReferenceLabel = withStyles(({ palette, spacing }: Theme) => ({
  root: {
    color: palette.grey[400],
    marginRight: spacing(0.5),
  },
}))(FsCaption);

export const ReferenceValue = withStyles(() => ({
  root: {
    fontSize: 14,
    fontWeight: 500,
  },
}))(FsCaption);

export const Description = withStyles(() => ({
  root: {},
}))((props: TypographyAllProps) => <FsBodySmall component="p" {...props} />);
